export default function ACLRolesDuplicate(attrs){
  this.load();
  const params = {action: "aclroles_duplicate", record : attrs.id};
  //var self = this;

  this.rest.post("customAction", params, (resp) => {
    if (resp.status) {
      this.href("#detail/ACLRoles/"+resp.message.data.record);
    }
    else{
      this.unLoad();
      this.alert(resp.errorMessage.text);
    }
  });
}
